// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QDNT","toggle":"styles_toggle__Lbq1u","preview":"styles_preview__3BG65"};